import { ref, watch, toValue, type MaybeRefOrGetter } from "vue";

const SHORTS_MAX_DURATION_SECONDS = 60;
const SHORTS_MAX_ASPECT_RATIO = 1;

export function useYouTubeShortDetection(videoUrl: MaybeRefOrGetter<string | undefined>) {
  const duration = ref<number | null>(null);
  const aspectRatio = ref<number | null>(null);
  const isShort = ref(false);
  const loading = ref(false);

  function probe(src: string) {
    loading.value = true;
    const video = document.createElement("video");
    video.preload = "metadata";
    video.muted = true;

    const cleanup = () => {
      video.removeAttribute("src");
      video.load();
      loading.value = false;
    };

    video.onloadedmetadata = () => {
      duration.value = Number.isFinite(video.duration) ? video.duration : null;
      aspectRatio.value =
        video.videoWidth && video.videoHeight
          ? video.videoWidth / video.videoHeight
          : null;
      isShort.value =
        !!duration.value &&
        duration.value <= SHORTS_MAX_DURATION_SECONDS &&
        !!aspectRatio.value &&
        aspectRatio.value <= SHORTS_MAX_ASPECT_RATIO;
      cleanup();
    };
    video.onerror = cleanup;

    video.src = src;
  }

  watch(
    () => toValue(videoUrl),
    url => {
      duration.value = null;
      aspectRatio.value = null;
      isShort.value = false;
      if (url) probe(url);
    },
    { immediate: true }
  );

  return { isShort, duration, aspectRatio, loading };
}
